import React from 'react'
import styled from '@emotion/styled'
import Section, { StyledSpan } from './Section'
import { VehiclePageNumber } from '../../constants'
import { ArrayUtils, QuestionUtils } from '../../utils/siteUtils'
const VerifiedCheckyImage = __PATH_PREFIX__ + '/VerifiedChecky.svg'

const VehicleDetailsSection = ({
  calculateViewChange,
  navigatePageWithState,
  options,
  trim = { displayName: '..' },
  engine = { displayName: '..' },
  transmission = { displayName: '..' },
  drivetrain = { displayName: '..' },
  color = { displayName: '..' },
  canEdit,
  prospectDocuments,
  getQuestionResponse,
  offer,
  prospect,
  genericOptions
}) => {
  const offerProspect = prospect || (offer && offer.prospect) || {}
  const offerVehicleBuildDataFlags = offerProspect.vehicleBuildDataFlags || offerProspect.vehicle.vehicleBuildDataFlags || {}
  const trimVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed
  const trimDisplayText = trimVinVerified ? offerProspect.vehicle.vehicleDescription.trim : trim && trim.displayName
  const enginesVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed && offerVehicleBuildDataFlags.enginesVinVerified
  const enginesDisplayText = enginesVinVerified ? offerProspect.vehicle.vehicleDescription.engine : engine.displayName
  const transmissionsVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed && offerVehicleBuildDataFlags.transmissionsVinVerified
  const transmissionDisplayText = transmissionsVinVerified ? offerProspect.vehicle.vehicleDescription.transmission : transmission.displayName
  const drivetrainsVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed && offerVehicleBuildDataFlags.drivetrainsVinVerified
  const drivetrainDisplayText = drivetrainsVinVerified ? offerProspect.vehicle.vehicleDescription.drivetrain : drivetrain.displayName
  const colorsVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed && offerVehicleBuildDataFlags.colorsVinVerified
  const colorsDisplayText = colorsVinVerified ? offerProspect.vehicle.vehicleDescription.color : color.displayName
  const optionsVinVerified = offerVehicleBuildDataFlags && offerVehicleBuildDataFlags.cadsUsed && offerVehicleBuildDataFlags.optionsVinVerified

  const optionsStr =
    (genericOptions &&
      genericOptions.length > 1 &&
      ArrayUtils.deDuplicate(genericOptions)
        .map(option => option)
        .join(', ')) ||
    (optionsVinVerified && ArrayUtils.deDuplicate(offerProspect.options.map(option => option.displayName)).join(', ')) ||
    (options && ArrayUtils.deDuplicate(options.filter(x => x.isSelected).map(option => option.displayName)).join(', '))
  const loadedOptions = (optionsVinVerified && offerProspect.options.map(option => option.displayName).join(', ')) || options
  const loaded = loadedOptions && trim.trimId && engine.engineId && transmission.transmissionId && drivetrain.drivetrainId && color.colorId
  let offerKeysValue = ''
  if (prospect && offerProspect.history && offerProspect.history.length !== 0) {
    const question = offerProspect.history.find(item => item.questionId === 'qp/79')
    offerKeysValue = question && question.value ? 'Yes' : 'No'
  }
  var keysValue = ''
  if (prospectDocuments && prospectDocuments.documents) {
    const keysQuestion = prospectDocuments.documents[0].items.find(item => item.questionId === 'qp/79')
    const { questionId, questionChoices } = QuestionUtils.getQuestionLabelAndChoices(keysQuestion)
    const questionValue = questionChoices[getQuestionResponse(questionId).v]
    keysValue = typeof questionValue === 'string' ? questionValue : questionValue ? 'Yes' : 'No'
  }
  if (keysValue === '') keysValue = offerKeysValue
  let uniqueViewStr = loaded && 'uniqueViewStr:' + trimDisplayText + enginesDisplayText + transmissionDisplayText + drivetrainDisplayText + colorsDisplayText + optionsStr + keysValue
  calculateViewChange('vehicleDetails', uniqueViewStr)
  return (
    <Section title={'Vehicle Details'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: VehiclePageNumber })}>
      <VerifiedByIconTextAndIconDiv>
        {enginesVinVerified && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan data-testid={'vd-lb-engine'}>Engine: </StyledSpan>
        {enginesDisplayText}
      </VerifiedByIconTextAndIconDiv>
      <br />
      <VerifiedByIconTextAndIconDiv>
        {transmissionsVinVerified && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan data-testid={'vd-lb-transmission'}>Transmission: </StyledSpan>
        {transmissionDisplayText}
      </VerifiedByIconTextAndIconDiv>
      <br />
      <VerifiedByIconTextAndIconDiv>
        {drivetrainsVinVerified && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan data-testid={'vd-lb-drivetrain'}>Drivetrain: </StyledSpan>
        {drivetrainDisplayText}
      </VerifiedByIconTextAndIconDiv>
      <br />
      <VerifiedByIconTextAndIconDiv>
        {colorsVinVerified && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan data-testid={'vd-lb-color'}>Color: </StyledSpan>
        {colorsDisplayText}
      </VerifiedByIconTextAndIconDiv>
      <br />
      <StyledSpan>2 Sets of Keys/Alarm Pads: </StyledSpan>
      {keysValue}
      <br />
      <br />
      <VerifiedByIconTextAndIconDiv>
        {optionsVinVerified && <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />}
        <StyledSpan data-testid={'vd-lb-featuresAndEquipment'}>Additional Features &amp; Standard Equipment: </StyledSpan>
      </VerifiedByIconTextAndIconDiv>
      <div>{optionsStr}</div>
    </Section>
  )
}

export default VehicleDetailsSection

const StyledCheckmarkIcon = styled.img`
  height: 14px;
  margin-right: 5px;
`

const VerifiedByIconTextAndIconDiv = styled.div`
  width: 100%;
  display: inline;
  vertical-align: bottom;
  text-align: center;
  height: 100%;
`
